/* Lunar motion v2: prepared cloud textures + CSS transforms. No canvas or per-frame JS. */
(() => {
  'use strict';
  if (window.LunarCinematicHero) return;
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  function create(root) {
    if (instances.has(root)) return;
    const image = root.querySelector('img');
    const host = root.closest('[data-lunar-atmosphere]');
    const control = host?.querySelector('[data-lunar-atmosphere-control]');
    const intro = host?.querySelector('.lunar-platform-modules__intro') || root;
    if (!image || !host) return;
    // The original controller stays in its hidden row; the existing footer button calls it.
    // No additional control is inserted into the artwork.
    let disposed = false, visible = !('IntersectionObserver' in window), texture = null;
    let loadingTexture = false, textureReady = false;
    function enabled() {
      if (reduced.matches || connection?.saveData) return false;
      if (control && !control.hidden) return control.textContent.trim() === 'Pause animation';
      try { const p = sessionStorage.getItem('lunar-sky-motion'); if (p) return p === 'play'; } catch (_) {}
      return host.dataset.lunarAtmospherePlaying === 'true';
    }
    function loadTexture() {
      if (loadingTexture || textureReady || !root.dataset.cloudSrc) return;
      loadingTexture = true;
      texture = new Image(); texture.decoding = 'async'; texture.fetchPriority = 'low';
      texture.onload = () => {
        if (disposed) return;
        textureReady = true;
        host.style.setProperty('--lunar-cloud-texture', 'url("' + texture.src + '")');
        root.dataset.cloudReady = 'true'; sync();
      };
      texture.onerror = () => { if (!disposed) root.dataset.cloudReady = 'unavailable'; };
      texture.src = root.dataset.cloudSrc;
    }
    function sync() {
      if (disposed) return;
      const motionDisabled = reduced.matches || Boolean(connection?.saveData);
      root.dataset.cinemaMotionDisabled = String(motionDisabled);
      if (control) {
        const label = control.textContent.trim() || 'Play animation';
        control.dataset.cinemaAction = label === 'Pause animation' ? 'pause' : 'play';
        control.title = label;
        control.disabled = motionDisabled;
      }
      const ready = image.complete && image.naturalWidth > 0;
      const playing = ready && visible && !document.hidden && enabled();
      root.dataset.cinemaReady = String(ready);
      root.dataset.cinemaPlaying = String(playing);
      host.dataset.lunarCinematicPlaying = String(playing);
      if (playing) loadTexture();
    }
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting; sync();
    }, {threshold: .01}) : null;
    const state = new MutationObserver(sync);
    state.observe(host, {attributes:true, attributeFilter:['data-lunar-atmosphere-playing']});
    if (control) state.observe(control, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden']});
    const change = () => sync();
    const clicked = event => { if (control && (event.target === control || control.contains(event.target))) queueMicrotask(sync); };
    image.addEventListener('load', change);
    document.addEventListener('visibilitychange', change);
    document.addEventListener('click', clicked);
    reduced.addEventListener('change', change);
    connection?.addEventListener?.('change', change);
    root.dataset.cinemaRenderer = 'compositor-clouds';
    observer?.observe(intro);
    instances.set(root, () => {
      disposed = true; observer?.disconnect(); state.disconnect();
      image.removeEventListener('load', change); document.removeEventListener('visibilitychange', change);
      document.removeEventListener('click', clicked); reduced.removeEventListener('change', change);
      connection?.removeEventListener?.('change', change);
      if (texture) { texture.onload = null; texture.onerror = null; }
      host.dataset.lunarCinematicPlaying = 'false';
    });
    sync();
  }
  function init(scope = document) {
    if (scope.matches?.('[data-lunar-cinema]')) create(scope);
    scope.querySelectorAll('[data-lunar-cinema]').forEach(create);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy,root) => { if (event.target.contains(root)) {destroy(); instances.delete(root);} });
  });
  window.LunarCinematicHero = {version:'2026-09-17.4-continuous-sky',refresh:() => init()};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
})();
